import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Grid, IconButton } from '@chakra-ui/react';
import { useT } from '@progress-fe/core';
import { Input } from '../../../../inputs';
import { VirtualTable } from '../../../../tables';
import { Svg } from '../../../../base';
const PseudoComponentsFC = ({ isSettings, favorites, components, selectedComponents, tableSx, onAddComponent, onDeleteComponent, onToggleFavorite, onAddAllComponents, onDeleteAllComponents }) => {
    const [query, setQuery] = useState('');
    const { t } = useT();
    const filteredOptionsByName = components.filter((opt) => opt.name.toLowerCase().includes(query.toLowerCase()) ||
        opt.structure?.toLowerCase().includes(query.toLowerCase()));
    const columns = [
        { name: t('fields.pseudoComponent'), align: 'left' },
        { name: t('fields.content'), align: 'left' },
        {
            name: '',
            width: '24px',
            columnTemplate: '24px',
            render: (id) => {
                if (!id) {
                    return undefined;
                }
                const isFavorite = favorites.has(id);
                return (onToggleFavorite && (_jsx(IconButton, { size: "2sm", "aria-label": "", variant: "transparent", icon: _jsx(Svg, { size: "s12", name: isFavorite ? 'FavoriteOn' : 'Favorite' }), onClick: () => onToggleFavorite(id), opacity: isFavorite ? 1 : 0, _groupHover: { opacity: !isFavorite ? 1 : undefined } })));
            }
        }
    ];
    const rows = filteredOptionsByName.map((opt) => ({
        key: opt.uuid,
        values: [opt.name, opt.structure || '', opt.uuid],
        isSelected: selectedComponents.has(opt.uuid),
        isDisabled: false
    }));
    return (_jsxs(Grid, { templateRows: "auto 1fr", gap: "8px", children: [_jsx(Grid, { gridTemplateColumns: "1fr", gap: "8px", children: _jsx(Input, { size: "xs", value: query, variant: "outline", placeholder: t('actions.search'), onChange: setQuery }) }), _jsx(VirtualTable, { rows: rows, columns: columns, isCheckboxShown: !isSettings, noItemsTitle: t('components.no'), onSelectAll: onAddAllComponents, onUnselectAll: onDeleteAllComponents, onSelect: onAddComponent, onUnselect: onDeleteComponent, tableSx: tableSx })] }));
};
export const PseudoComponents = observer(PseudoComponentsFC);
//# sourceMappingURL=PseudoComponents.js.map